/**
 * Shared MUI `sx` blocks for form fields.
 *
 * Use `fieldSx` on any `<TextField>`, `<FormControl>`, or `<Select>` that
 * should match the canonical Logistics Hub look:
 *   - compact label (0.875rem)
 *   - teal focused label
 *   - grey-200 idle border
 *   - teal focused border
 *
 * If you need hover border styling or a rounded/white variant (login-style),
 * keep a local `fieldSx` for that screen rather than mutating this one.
 */
export const fieldSx = {
  '& .MuiInputLabel-root': { fontSize: '0.875rem' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#009688' },
  '& .MuiOutlinedInput-root': {
    fontSize: '0.875rem',
    '& fieldset': { borderColor: 'var(--grey-200)' },
    '&.Mui-focused fieldset': { borderColor: '#009688' },
  },
};
